export const isRefNameUrlSafe = (refName: string): boolean =>
  !/[/#%]/.test(refName);
